import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const usersApi = {};

usersApi.getUserByAuth0Id = async (auth0Id) => {
  try {
    // encodeURIComponent is needed for this param because the auth0 id contains a | which Safari won't encode automatically
    const url = `${consumerBaseUrl}/users/auth0/${encodeURIComponent(auth0Id)}`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    logger.info(response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getUserByAuth0Id", error);
    logger.error(error);
    throw error;
  }
};

usersApi.createHistoricalLogin = async (auth0Id) => {
  try {
    const body = {
      auth0_user_id: auth0Id,
    };
    const url = `${consumerBaseUrl}/patient_portal/historical_ptp_logins`;
    console.log("API REQUEST", "POST", url, body);
    const response = await axios.post(url, body);
    console.log("API RESPONSE", "POST", url, response.status, response.data);
    logger.info(response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "POST", "createHistoricalLogin", error);
    logger.error(error);
    throw error;
  }
};
export default usersApi;
